import React, { useState, useEffect, useMemo } from "react";
import { Button, DataTable, clientSortRows } from "./ui";
import { MDBContainer, MDBRow, MDBCol, MDBInput, MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, MDBCard, MDBCardBody } from "mdb-react-ui-kit";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Toolbar from "./Toolbar";
import { useTranslation } from "react-i18next";

function AppsPage() {
  const { t } = useTranslation("translation");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [tableSortColumn, setTableSortColumn] = useState("dateAdded");
  const [sortDirection, setSortDirection] = useState("desc");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate data fetch
    const timer = setTimeout(() => setLoading(false), 1200);
    return () => clearTimeout(timer);
  }, []);

  const appsData = [
    {
      id: 1,
      appName: "Door Dash",
      catalogName: "Breakfast Catalog",
      commissionRate: "5%",
      dateAdded: "2023-12-01",
    },
    {
      id: 2,
      appName: "Zomato",
      catalogName: "Catalog 2",
      commissionRate: "6%",
      dateAdded: "2023-11-25",
    },
    {
      id: 3,
      appName: "Deliveroo",
      catalogName: "Breakfast Catalog",
      commissionRate: "11%",
      dateAdded: "2023-11-30",
    },
    {
      id: 4,
      appName: "Hunger Station",
      catalogName: "Catalog 3",
      commissionRate: "12%",
      dateAdded: "2023-11-20",
    },
  ];

  // Filter function must be defined here before invocation
  const filterApps = () => {
    let updatedApps = [...appsData];

    // Search filter
    if (searchQuery) {
      updatedApps = updatedApps.filter((app) =>
        app.appName.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Date filter
    if (selectedDate) {
      updatedApps = updatedApps.filter((app) => app.dateAdded === selectedDate);
    }

    return updatedApps;
  };

  const filteredApps = useMemo(() => {
    const list = filterApps();
    return clientSortRows(list, tableSortColumn, sortDirection, (app, col) => {
      switch (col) {
        case "dateAdded":
          return app.dateAdded ? new Date(app.dateAdded).getTime() : 0;
        case "commissionRate":
          return parseFloat(String(app.commissionRate).replace("%", "")) || 0;
        default:
          return String(app[col] || "").toLowerCase();
      }
    });
  }, [searchQuery, selectedDate, tableSortColumn, sortDirection]);

  const columns = useMemo(
    () => [
      {
        id: "appName",
        header: "App Name",
        sortable: true,
        strong: true,
        render: (app) => app.appName,
      },
      {
        id: "catalogName",
        header: "Catalog Name",
        sortable: true,
        render: (app) => app.catalogName,
      },
      {
        id: "commissionRate",
        header: "Commission Rate",
        sortable: true,
        render: (app) => app.commissionRate,
      },
      {
        id: "dateAdded",
        header: "Date Added",
        sortable: true,
        render: (app) => app.dateAdded,
      },
      {
        id: "actions",
        header: "Actions",
        hideable: false,
        render: () => (
          <div className="d-flex gap-2" onClick={(e) => e.stopPropagation()}>
            <Button color="secondary" outline size="sm">
              Edit
            </Button>
            <Button color="danger" outline size="sm">
              Delete
            </Button>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <div className="apps-page-root">
      <MDBContainer fluid className="p-4 content-area flex-grow-1">
        <h2 className="mb-4" style={{ color: "#333" }}>
          All Apps
        </h2>

        {/* Filters Section */}
        <MDBRow className="align-items-center mb-4 apps-filters-row">
       
        
            {loading ? (
              <Skeleton
                height={40}
                width={"100%"}
                style={{ borderRadius: 8 }}
              />
            ) : (
              <>

              <Toolbar 
              showSearch={true} 
              searchPlaceHolder="Search Apps"
              searchQuery={searchQuery}
              handleSearch={(e)=> setSearchQuery(e.target.value)}
              showDateFilter={true}
              selectedDate={selectedDate}
              handleDateChange={(e) => setSelectedDate(e.target.value)}
              showButton1={true}
              button1Text={"Add App"}
              />
              {/* <MDBInput
                type="text"
                label="Search Apps"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{ borderRadius: "8px" }}
              /> */}
              </>
            )}
          

          {/* <MDBCol md="3">
            {loading ? (
              <Skeleton
                height={40}
                width={"100%"}
                style={{ borderRadius: 8 }}
              />
            ) : (
              <MDBInput
                type="date"
                label="Filter by Date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
                style={{ borderRadius: "8px" }}
              />
            )}
          </MDBCol>

          <MDBCol md="3">
            {loading ? (
              <Skeleton
                height={40}
                width={"100%"}
                style={{ borderRadius: 8 }}
              />
            ) : (
              <SortDropdown
                selectedSort={sortOrder}
                setSelectedSort={setSortOrder}
                sortOrders={setSortOrder}
              />
            )}
          </MDBCol>

          <MDBCol md="3" className="d-flex justify-content-end">
            {loading ? (
              <Skeleton height={40} width={120} style={{ borderRadius: 8 }} />
            ) : (
              <Button color="primary" style={{ borderRadius: "8px" }}>
                + Add App
              </Button>
            )}
          </MDBCol> */}
        </MDBRow>

        {/* Apps Table */}
        <DataTable
          tableId="apps-page"
          title={t("sidebar.appManagement")}
          columns={columns}
          data={filteredApps}
          rowKey="id"
          loading={loading}
          emptyState="No apps to display"
          sort={{
            column: tableSortColumn,
            direction: sortDirection,
            onChange: ({ column, direction }) => {
              setTableSortColumn(column);
              setSortDirection(direction);
            },
          }}
        />
      </MDBContainer>
    </div>
  );
}

export default AppsPage;
